import store from '../../../'
import { ActionType } from '../../../constants/ActionTypes';
import { NotificationType } from './Notification'
import { CustomErrors } from '../../../constants/Errors/CustomErrors';
import Utils from '../../../services/Utils';
import SiteEvent from '../../../services/events/SiteEvent';
import { Browser } from '../../../services/helpers/Browser';
export const dispatchNotification = (messageType, message, id, type) => ({
    type: ActionType.DISPATCH_NOTIFICATION,
    payload: { message, messageType, id, type }
})

const NotificationService = {

    success({ message, code }, timer = 5000) {
        if (!CustomErrors[code]) {
            const id = Utils.generateUUID();
            store.dispatch(dispatchNotification(NotificationType.Success, message, id));
            setTimeout(NotificationService.close, timer, id);
        }

        SiteEvent.dispatch({
            target: null,
            rootTarget: null,
            type: SiteEvent.action.Success,
            category: SiteEvent.category.Notification,
            data: { success_message: message }
        })
    },

    online({ message, code }) {
        if (!CustomErrors[code]) {
            const id = Utils.generateUUID();
            store.dispatch(dispatchNotification(NotificationType.Online, message, id));
            NotificationService.networkCallback();
        }
    },

    networkCallback() {
        const networkNotification = document.getElementById("network-notification");
        networkNotification && networkNotification.remove();
        const networkNotificationBg = document.getElementById("network-notification-background");
        networkNotificationBg && networkNotificationBg.remove();
    },

    network({ message, code }, timer = 5000) {
        this.close();
        const networkNotification = document.getElementById("network-notification");
        networkNotification && networkNotification.remove();
        const networkNotificationBg = document.getElementById("network-notification-background");
        networkNotificationBg && networkNotificationBg.remove();

        const wrapper = document.createElement("div");
        wrapper.id = 'network-notification';
        wrapper.className = `tb--notice-wrapper${Browser.isMobNativeApp() ? ' mobile-app-notice' : ''}`;
        const container = document.createElement("div");
        container.className = 'tb--notice-container move-up-leave';
        const container2 = document.createElement("div");
        container2.className = `tb--notice-content tb--notice-network_${!code ? 'offline' : code === 2 ? 'poor' : 'online'} tb--flex tb--justify-between tb--align-center`;
        const innerDiv1 = document.createElement("div");
        innerDiv1.className = 'tb--flex tb--align-center';
        const i = document.createElement("i");
        i.className = `${code === 2 ? 'digi_icon-poor_internet' : `digi_icon-wifi_${code ? 'on' : 'off'}`} tb--f-20`;

        const span = document.createElement("span");
        span.className = 'tb--notice-msg tb--ph-8';
        span.innerHTML = message;
        innerDiv1.appendChild(i);
        innerDiv1.appendChild(span);
        const innerDiv2 = document.createElement("div");
        innerDiv2.className = 'tb--f-18';
        if (code) {
            const i2 = document.createElement("i");
            i2.className = 'digi_icon-close tb--cp';
            i2.onclick = NotificationService.networkCallback;
            innerDiv2.appendChild(i2);
        }
        container2.appendChild(innerDiv1);
        container2.appendChild(innerDiv2);
        wrapper.appendChild(container);
        container.appendChild(container2);

        if (!code) {
            const background = document.createElement("div");
            background.id = "network-notification-background";
            background.className = "tb--modal-lvl1";
            const bgContent = document.createElement("div");
            bgContent.className = "tb--modal-lvl2";
            background.appendChild(bgContent);
            document.body.appendChild(background);
        }
        document.body.appendChild(wrapper);
    },

    error({ message, code }, timer = 5000, optionalData = {}) {
        if (!CustomErrors[code]) {
            //Stupid code just for passing Jest test )))
            const id = Utils?.generateUUID();
            store.dispatch(dispatchNotification(NotificationType.Error, message, id));
            setTimeout(NotificationService.close.bind(this, id), timer);
        }

        SiteEvent.dispatch({
            target: null,
            rootTarget: null,
            type: SiteEvent.action.Error,
            category: SiteEvent.category.Notification,
            data: {
                error_message: message,
                error_code: code,
                ...optionalData
            }
        })
    },

    close(id, type) {
        store.dispatch(dispatchNotification(NotificationType.Close, null, id, type));
    }
}

export default NotificationService;